export default {"src":"/_next/static/media/mb_brand.e94504c5.svg","height":124,"width":100,"blurWidth":0,"blurHeight":0};